module.exports = __webpack_public_path__ + "img/edit-figma.5d5801de.svg";